
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const ForgotPasswordFooter: React.FC = () => {
  return (
    <Button asChild variant="outline" size="sm">
      <Link to="/login" className="flex items-center">
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Login
      </Link>
    </Button>
  );
};
